{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Jūs esat pārsniedzis sarunu ierobežojumu. Hacker plāns pieļauj tikai 500 sarunas.",
      "INBOXES": "Jūs esat pārsniedzis iesūtnes ierobežojumu. Hacker plāns atbalsta tikai vietnes tiešraides tērzēšanu. Papildu iesūtnēm, piemēram, e-pastam, WhatsApp utt., ir nepieciešams maksas plāns.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Lūdzu, sazinieties ar savu administratoru, lai modernizētu plānu un turpinātu izmantot visas funkcijas."
    },
    "TITLE": "Konta iestatījumi",
    "SUBMIT": "Atjaunināt iestatījumus",
    "BACK": "Atpakaļ",
    "DISMISS": "Atcelt",
    "UPDATE": {
      "ERROR": "Nevarēja atjaunināt iestatījumus, mēģiniet vēlreiz!",
      "SUCCESS": "Konta iestatījumi ir veiksmīgi atjaunināti"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Dzēsiet savu Kontu",
      "NOTE": "Tiklīdz izdzēsīsiet savu kontu, visi Jūsu dati tiks dzēsti.",
      "BUTTON_TEXT": "Izdzēst Savu Kontu",
      "CONFIRM": {
        "TITLE": "Dzēst Kontu",
        "MESSAGE": "Konta dzēšana ir neatgriezeniska. Ievadiet sava konta nosaukumu, lai apstiprinātu, ka vēlaties to neatgriezeniski dzēst.",
        "BUTTON_TEXT": "Dzēst",
        "DISMISS": "Atcelt",
        "PLACE_HOLDER": "Lai apstiprinātu, lūdzu, uzrakstiet {accountName}"
      },
      "SUCCESS": "Konts atzīmēts dzēšanai",
      "FAILURE": "Nevarēja izdzēst kontu, mēģiniet vēlreiz!",
      "SCHEDULED_DELETION": {
        "TITLE": "Kontu ir Ieplānots Dzēst",
        "MESSAGE_MANUAL": "Šo kontu ir ieplānots dzēst šādā datumā: {deletionDate}. To pieprasīja administrators. Jūs varat atcelt dzēšanu pirms šī datuma.",
        "MESSAGE_INACTIVITY": "Šo kontu ir plānots dzēst šādā datumā: {deletionDate} konta neaktivitātes dēļ. Jūs varat atcelt dzēšanu pirms šī datuma.",
        "CLEAR_BUTTON": "Atcelt Ieplānoto Dzēšanu"
      }
    },
    "FORM": {
      "ERROR": "Lūdzu, izlabojiet veidlapas kļūdas",
      "GENERAL_SECTION": {
        "TITLE": "Vispārīgie iestatījumi",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Konta ID",
        "NOTE": "Šis ID ir nepieciešams, ja veidojat uz API balstītu integrāciju"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Konta nosaukums",
        "PLACEHOLDER": "Jūsu konta nosaukums",
        "ERROR": "Lūdzu, ievadiet derīgu konta nosaukumu"
      },
      "LANGUAGE": {
        "LABEL": "Vietnes valoda",
        "PLACEHOLDER": "Jūsu konta nosaukums",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Ienākošā e-pasta domēns",
        "PLACEHOLDER": "Domēns, kurā saņemsiet e-pastus",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Atbalsta e-pasts",
        "PLACEHOLDER": "Jūsu uzņēmuma atbalsta e-pasts",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Atjaunināt",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Jūsu kontam ir iespējota sarunu nepārtrauktība ar e-pastiem.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Tagad Jūs varat saņemt e-pasta ziņojumus savā pielāgotajā domēnā."
      }
    },
    "UPDATE_CHATWOOT": "Ir pieejams Chatwoot {latestChatwootVersion} jauninājums. Lūdzu, atjauniniet savu programmatūru.",
    "LEARN_MORE": "Uzzināt vairāk",
    "PAYMENT_PENDING": "Jūsu maksājums tiek gaidīts. Lūdzu, atjauniniet savu maksājumu informāciju, lai turpinātu lietot Chatwoot",
    "UPGRADE": "Modernizējieties, lai turpinātu lietot Chatwoot",
    "LIMITS_UPGRADE": "Jūsu konts ir pārsniedzis lietošanas ierobežojumus. Lūdzu, uzlabojiet savu abonementu, lai turpinātu izmantot Chatwoot",
    "OPEN_BILLING": "Atvērt norēķinus"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Nospiediet enter, lai izvēlētos",
      "ENTER_TO_REMOVE": "Nospiediet enter, lai noņemtu",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Izvēlieties vienu",
      "SELECT": "Izvēlieties"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Paziņojumi",
    "MARK_ALL_DONE": "Atzīmēt visu kā pabeigtu",
    "DELETE_TITLE": "dzēsts",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nelasīti paziņojumi",
      "ALL_NOTIFICATIONS": "Skatīt visus paziņojumus",
      "LOADING_UNREAD_MESSAGE": "Notiek nelasītu paziņojumu ielāde...",
      "EMPTY_MESSAGE": "Jums nav nelasītu paziņojumu"
    },
    "LIST": {
      "LOADING_MESSAGE": "Notiek paziņojumu ielāde...",
      "404": "Nav paziņojumu",
      "TABLE_HEADER": [
        "Nosaukums",
        "Telefona numurs",
        "Sarunas",
        "Pēdējā Sazināšanās"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Jauna saruna",
      "conversation_assignment": "Saruna Piešķirta",
      "assigned_conversation_new_message": "Jauns ziņojums",
      "participating_conversation_new_message": "Jauns ziņojums",
      "conversation_mention": "Pieminēt",
      "sla_missed_first_response": "SLA Nokavēts",
      "sla_missed_next_response": "SLA Nokavēts",
      "sla_missed_resolution": "SLA Nokavēts"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Bezsaistē",
      "RECONNECTING": "Notiek savienojuma atjaunošana...",
      "RECONNECT_SUCCESS": "Atkārtoti izveidots savienojums"
    },
    "BUTTON": {
      "REFRESH": "Atjaunot"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Meklēt vai pāriet uz",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Vispārēji",
      "REPORTS": "Pārskati",
      "CONVERSATION": "Saruna",
      "BULK_ACTIONS": "Lielapjoma Darbības",
      "CHANGE_ASSIGNEE": "Mainīt Pilnvaroto",
      "CHANGE_PRIORITY": "Mainīt prioritāti",
      "CHANGE_TEAM": "Mainīt Komandu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "ADD_LABEL": "Pievienot sarunai etiķeti",
      "REMOVE_LABEL": "Noņemt etiķeti no sarunas",
      "SETTINGS": "Iestatījumi",
      "AI_ASSIST": "AI Palīgs",
      "APPEARANCE": "Izskats",
      "SNOOZE_NOTIFICATION": "Atlikt Paziņojumu"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Doties uz Sarunu Informācijas Paneli",
      "GO_TO_CONTACTS_DASHBOARD": "Doties uz Kontaktpersonu Informācijas Paneli",
      "GO_TO_REPORTS_OVERVIEW": "Doties uz Pārskatu Kopsavilkumu",
      "GO_TO_CONVERSATION_REPORTS": "Doties uz Sarunu Pārskatiem",
      "GO_TO_AGENT_REPORTS": "Doties uz Aģentu Pārskatiem",
      "GO_TO_LABEL_REPORTS": "Doties uz Etiķešu Pārskatiem",
      "GO_TO_INBOX_REPORTS": "Doties uz Iesūtnes Pārskatiem",
      "GO_TO_TEAM_REPORTS": "Doties uz Komandas Pārskatiem",
      "GO_TO_SETTINGS_AGENTS": "Doties uz Aģentu Iestatījumiem",
      "GO_TO_SETTINGS_TEAMS": "Doties uz Komandas Iestatījumiem",
      "GO_TO_SETTINGS_INBOXES": "Doties uz Iesūtnes Iestatījumiem",
      "GO_TO_SETTINGS_LABELS": "Doties uz Etiķešu Iestatījumiem",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Doties uz Sagatavoto Atbilžu Iestatījumiem",
      "GO_TO_SETTINGS_APPLICATIONS": "Doties uz Lietojumprogrammas Iestatījumiem",
      "GO_TO_SETTINGS_ACCOUNT": "Doties uz Konta Iestatījumiem",
      "GO_TO_SETTINGS_PROFILE": "Doties uz Profila Iestatījumiem",
      "GO_TO_NOTIFICATIONS": "Doties uz Paziņojumiem",
      "ADD_LABELS_TO_CONVERSATION": "Pievienot sarunai etiķeti",
      "ASSIGN_AN_AGENT": "Piešķirt aģentu",
      "AI_ASSIST": "AI Palīgs",
      "ASSIGN_PRIORITY": "Piešķirt prioritāti",
      "ASSIGN_A_TEAM": "Piešķirt komandu",
      "MUTE_CONVERSATION": "Izslēgt sarunu",
      "UNMUTE_CONVERSATION": "Ieslēgt sarunu",
      "REMOVE_LABEL_FROM_CONVERSATION": "Noņemt etiķeti no sarunas",
      "REOPEN_CONVERSATION": "Atkārtoti atvērt sarunu",
      "RESOLVE_CONVERSATION": "Atrisināt sarunu",
      "SEND_TRANSCRIPT": "Nosūtīt uz e-pastu transkriptu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "UNTIL_NEXT_REPLY": "Līdz nākamajai atbildei",
      "UNTIL_NEXT_WEEK": "Līdz nākamajai nedēļai",
      "UNTIL_TOMORROW": "Līdz rītdienai",
      "UNTIL_NEXT_MONTH": "Līdz nākamajam mēnesim",
      "AN_HOUR_FROM_NOW": "Līdz stundai, no šī brīža",
      "UNTIL_CUSTOM_TIME": "Pielāgot...",
      "CHANGE_APPEARANCE": "Mainīt Izskatu",
      "LIGHT_MODE": "Gaišs",
      "DARK_MODE": "Tumšs",
      "SYSTEM_MODE": "Sistēma",
      "SNOOZE_NOTIFICATION": "Atlikt Paziņojumu"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Notiek informācijas paneļa lietotnes ielāde..."
  },
  "COMMON": {
    "OR": "Vai",
    "CLICK_HERE": "noklikšķiniet šeit"
  }
}
